import type { FC } from "react";
import { Box, Button } from "@mui/material";
import { FoodsIcon, SearchBox } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import { useCompanyListContext } from "./CompanyListContext";
import { GridTableActions } from "src/components/Grid/headers/GridTableActions";
import { useColumnsTableAction } from "src/components/Grid/headers/useColumnsTableAction";
import { CompanyModal } from "./CompanyModal";
import { useQueryClient } from "react-query";
import { allOrganizationKey } from "src/api/client-api/company/useGetAllOrganization";
import { CREATE, ORGANIZATION, useFoodpilotContext } from "src/context/FoodpilotContext";

export const CompanyGridHeader: FC = () => {
    const { t } = useTranslation();
    const { searchCompany, setSearchCompany, showCreateModal, setShowCreateModal, isProvider, mrt_columns } =
        useCompanyListContext();
    const columnsAction = useColumnsTableAction(mrt_columns);
    const queryClient = useQueryClient();
    const { canUser } = useFoodpilotContext();
    const canCreateOrganization = canUser(CREATE, ORGANIZATION);

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "space-between",
                    alignItems: { xs: "stretch", md: "center" },
                    padding: "24px 32px 24px",
                    gap: "12px",
                }}
            >
                {/* Search Field */}
                <Box sx={{ width: { xs: "100%", md: "323px" } }}>
                    <SearchBox
                        variant="standalone"
                        value={searchCompany}
                        onChange={(value) => setSearchCompany(value)}
                        placeholder={t("search", "Search...")}
                    />
                </Box>

                {/* Action Buttons */}
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "center" }}>
                    <GridTableActions actions={[columnsAction]} appearance="legacy" />

                    {canCreateOrganization && (
                        <Button
                            variant="primary"
                            startIcon={<FoodsIcon icon="plus" size={1} />}
                            onClick={() => setShowCreateModal(true)}
                        >
                            {t("company.create", "Create company")}
                        </Button>
                    )}
                </Box>
            </Box>

            {/* Create Modal */}
            {canCreateOrganization && (
                <CompanyModal
                    open={showCreateModal}
                    onClose={() => setShowCreateModal(false)}
                    onSuccess={() => {
                        queryClient.invalidateQueries([allOrganizationKey]);
                        setShowCreateModal(false);
                    }}
                />
            )}
        </>
    );
};
